import { faGun } from '@fortawesome/free-solid-svg-icons';
import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Grid from 'Components/Atoms/Grid/Grid';
import IconWrapper from 'Components/Atoms/IconWrapper/IconWrapper';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import Card from 'Components/Molecules/Card/Card';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import { Link } from 'react-router-dom';
import { ROUTE, ROUTES } from 'Services/Route/Route.types';

const SettingsMenu: any = [{
    path: ROUTE.SETTING.MAILGUN,
    icon: faGun,
    title: 'Mailgun',
    description: 'Ga door naar de instellingen van mailgun'
}];

const ExtensionsSettingsPage = ({
    ...props
}: any) => {
    return <SettingsTemplate
        breadcrumbs={
            <Breadcrumbs>
                <BreadcrumbItem path={ROUTES.SETTINGS.path}>Instellingen</BreadcrumbItem>
                <BreadcrumbItem>Extensies</BreadcrumbItem>
            </Breadcrumbs>
        }
        description="Extensie instellingen"
    >
        <Grid axis='vertical'>
            {
                SettingsMenu.map(i =>
                    <Link to={i.path} style={{textDecoration: 'none'}}>
                        <Card axis="horizontal" state="link">
                            <TitleGroup iconBefore={
                                <IconWrapper>
                                    <FontAwesomeIcon icon={i.icon} size="2x" />
                                </IconWrapper>
                            }>
                                <Title size="xsmall" weight='bold' transform='uppercase'>{i.title}</Title>
                                <Title size="xsmall" color='secondary'>{i.description}</Title>
                            </TitleGroup>
                            <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                        </Card>
                    </Link>
                )
            }
        </Grid>
    </SettingsTemplate>
}

export default ExtensionsSettingsPage;